import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../components/footer-main/footer-main';
import { FooterDesktopComponent } from '../../components/footer-desktop/footer-desktop';
import { HeaderComponent } from '../../components/header-main/header-main';
import { HeaderDesktopComponent } from '../../components/header-desktop/header-desktop';

@Component({
    imports: [CommonModule, FooterComponent, FooterDesktopComponent, HeaderComponent, HeaderDesktopComponent],
    selector: 'app-pricing',
    standalone: true,
    styleUrls: ['./pricing.page.scss'],
    templateUrl: './pricing.page.html'
})
export class PricingPage implements OnInit {
  showLaunch: boolean = false;
  showFinal: boolean = false;
  pricings: any=[];

  types: any=['Gig List', 'Gig Work*', 'Job List', 'Job Hunt', 'Volunteer Request', 'Volunteer', 'Promote']
  member: any= ['FREE', '5-15%', 'FREE', 'FREE', 'FREE', 'FREE', 'FREE', ];
  guest: any=[] //['FREE', '15%', '$20', 'FREE', 'FREE', 'FREE', '$20', ];

  constructor(
    private metaService: Meta,
    private titleService: Title,
  ) { }

  ngOnInit() {
    this.titleService.setTitle('Pricing: gigexchange');
    this.metaService.updateTag(
      { name: 'description', property: 'og:description', content: 'Check out our fair pricing.' }
    )
  }

}
